import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/system";
import { ROUTES } from "../config/routes";
import {
  SideBarSearchLogo,
  SideBarHomeLogo,
  SideBarReportsLogo,
  SideBarProfileLogo,
  SideBarLogoutLogo,
  SideBarLogo,
  SideBarAddLogo,
  SideBarSmallLogo,
  SideBarMarketplaceLogo,
} from "../assets/icons/index.js";
import {
  DISPLAY_FLEX,
  FLEX_DIRECTION_COLUMN,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  MAX_WIDTH,
  POSITION_FIXED,
  FLEX_ALIGN_CENTER,
  TEXT_DECORATION_NONE,
  FLEX_ALIGN_STRETCH,
  BORDER_PRIMARY,
  BORDER_SECONDARY,
} from "../config/styles.js";
import { Typography, Box } from "@mui/material";
import { GLOBAL_SIDEBAR_CONSTANTS, ADMIN_TYPE } from "../config/constants.js";
import { colors } from "../config/colors.js";

const GlobalSideBarStyled = styled("div")(({ theme }) => ({
  zIndex: 999,
  position: POSITION_FIXED,
  height: MAX_WIDTH,
  background: theme.palette.background.default,
  float: "left",
  padding: "1rem",
  borderRight: BORDER_SECONDARY,
  "& .flex-column-with-height": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    height: MAX_WIDTH,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  },
  "& .flex-column": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    background: theme.palette.background.default,
  },
  "& .qkr-section": {
    display: DISPLAY_FLEX,
    alignItems: FLEX_ALIGN_CENTER,
    height: "36px",
    padding: ".5rem",
    gap: ".5rem",
    textDecoration: TEXT_DECORATION_NONE,
    color: theme.palette.text.primary,
    borderRadius: "4px",
    border: BORDER_PRIMARY,
    background: theme.palette.secondary.contrastText,
    cursor: "pointer",
  },
  "& .nav-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    gap: ".5rem",
    padding: "0",
  },
  "& .menu-container-item": {
    display: DISPLAY_FLEX,
    height: "36px",
    alignItems: FLEX_ALIGN_CENTER,
    alignSelf: FLEX_ALIGN_STRETCH,
    borderRadius: "4px",
    background: theme.palette.background.default,
    gap: ".5rem",
    textDecoration: TEXT_DECORATION_NONE,
    padding: "0 .5rem",
    "&:hover": {
      background: theme.palette.secondary.contrastText,
    },
  },
  "& .menu-container-item-active": {
    display: DISPLAY_FLEX,
    height: "36px",
    alignItems: FLEX_ALIGN_CENTER,
    alignSelf: FLEX_ALIGN_STRETCH,
    borderRadius: "4px",
    background: theme.palette.secondary.contrastText,
    gap: ".5rem",
    textDecoration: TEXT_DECORATION_NONE,
    padding: "0 .5rem",
    color: theme.palette.primary.main,
  },
}));

const globalNavList = [
  {
    eventId: "link-1",
    title: "Search",
    logo: SideBarSearchLogo,
    link: ROUTES.SEARCH,
    disabled: false,
  },
  {
    eventId: "link-2",
    title: "Home",
    logo: SideBarHomeLogo,
    link: ROUTES.MAIN_LANDING_PAGE,
    disabled: false,
  },
  {
    eventId: "link-3",
    title: "Reports",
    logo: SideBarReportsLogo,
    link: ROUTES.REPORTS,
    disabled: false,
  },
  // {
  //   eventId: "link-4",
  //   title: "Marketplace",
  //   logo: SideBarMarketplaceLogo,
  //   link: ROUTES.MARKETPLACE,
  //   disabled: false,
  //   MainMenu: true,
  // },
];

export const GlobalSideBar = ({ type = "normal" }) => {
  let roleData = localStorage.getItem("role");
  const [role, setRole] = useState(
    localStorage.getItem("role") || ADMIN_TYPE.SUPER_ADMIN
  );
  useEffect(() => {
    if (roleData === ADMIN_TYPE.SUPER_ADMIN) {
      setRole(roleData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRole(roleData);
  }, [roleData]);

  const location = useLocation();
  const activeItem = location.pathname;
  let firstName = localStorage.getItem("firstName");
  let lastName = localStorage.getItem("lastName");
  const isTypeNormal = type === "normal";
  const onLogOut = () => {
    localStorage.clear();
  };

  return (
    <GlobalSideBarStyled sx={{ width: isTypeNormal ? "220px" : "68px" }}>
      <div className="flex-column-with-height">
        <Box
          as="div"
          className="flex-column"
          sx={{ width: isTypeNormal ? "188px !important" : "36px !important" }}
        >
          <div className={isTypeNormal ? "mx-2" : ""}>
            {isTypeNormal ? <SideBarLogo /> : <SideBarSmallLogo />}
          </div>

          <div className="my-3">
            {role !== ADMIN_TYPE.SCHOOL_ADMIN && (
              <Box
                as={Link}
                className="qkr-section"
                sx={{
                  width: isTypeNormal ? "188px !important" : "36px !important",
                }}
                to={{
                  pathname: ROUTES.MAIN_LANDING_PAGE,
                  state: {
                    fromScreen: "migrateFromQKR",
                  },
                }}
                state={{ fromScreen: "migrateFromQKR" }}
              >
                <SideBarAddLogo />
                {isTypeNormal && (
                  <Typography variant="body1">
                    {GLOBAL_SIDEBAR_CONSTANTS.HEADER}
                  </Typography>
                )}
              </Box>
            )}
          </div>
          {role !== ADMIN_TYPE.SCHOOL_ADMIN && (
            <Nav className="nav-container">
              {globalNavList.map((item) => {
                const isItemActive = activeItem === item.link && !item.disabled;
                return (
                  <Nav.Link
                    eventKey={item.eventId}
                    as="div"
                    key={item.eventId}
                    bsPrefix="test-class"
                  >
                    <Link
                      to={item.link}
                      state={{
                        fromScreen:
                          item.eventId === "link-3" ? "MainLanding" : "",
                      }}
                      className={
                        isItemActive
                          ? "menu-container-item-active"
                          : "menu-container-item"
                      }
                    >
                      {item.logo({
                        bgColor: isItemActive
                          ? colors.primary
                          : colors.nonActive,
                      })}
                      {isTypeNormal && (
                        <Typography
                          variant="body1"
                          sx={{
                            color: isItemActive
                              ? colors.custom
                              : colors.nonActive,
                          }}
                        >
                          {item.title}
                        </Typography>
                      )}
                    </Link>
                  </Nav.Link>
                );
              })}
            </Nav>
          )}
        </Box>
        <Nav className="nav-container">
          <Nav.Link eventKey="link-6" as="div" bsPrefix="test-class">
            <Link className="menu-container-item">
              <SideBarProfileLogo />
              {isTypeNormal && (
                <Typography
                  variant="body1"
                  sx={{
                    color: colors.custom,
                  }}
                >
                  {`${firstName} ${lastName}`}
                </Typography>
              )}
            </Link>
          </Nav.Link>

          <Nav.Link
            eventKey="link-7"
            as="div"
            onClick={onLogOut}
            bsPrefix="test-class"
          >
            <Link className="menu-container-item" to={ROUTES.LOGIN}>
              <SideBarLogoutLogo />
              {isTypeNormal && (
                <Typography
                  variant="body1"
                  sx={{
                    color: colors.nonActive,
                  }}
                >
                  {GLOBAL_SIDEBAR_CONSTANTS.LOGOUT}
                </Typography>
              )}
            </Link>
          </Nav.Link>
        </Nav>
      </div>
    </GlobalSideBarStyled>
  );
};

GlobalSideBar.propTypes = {
  type: PropTypes.string,
};
